function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.953 7.235c.078-.665.524-1.527 1.362-1.923-1.26-.191-2.282.396-2.791 1.15-.809-.173-1.305-.183-2.118-.031-.516-.39-1.122-1.277-1.075-2.205-.975 1.145-1.176 2.008-1.056 3.038C-2.481 13.954 2.572 22 9.775 22 16.244 22 20 17.072 20 12.022c0-3.406-1.548-6.362-3.128-7 .59.646 1.26 2.332 1.13 3.499-1.275-3.308-4.46-4.586-5.533-4.518 3.528 1.37 4.373 6.034 4.06 7.41-.307-1.614-1.286-3.004-1.872-3.372 3.417 7.972-4.835 10.422-7.353 7.655.65.168 1.931.085 2.891-.555.899-.6.983-.634 1.56-.679.686-.053-.04-1.401-1.538-1.173-.617.094-1.632.815-2.881.34-1.507-.574-1.46-2.623.096-2.007.337-.435.089-1.258.089-1.258.452-.412 1.023-.702 1.37-.907.228-.134.83-.504.795-1.225-.122-.095-.32-.217-.766-.192-1.736.11-1.853-.515-1.967-.805z"
});

var SvgBrowserFf = function SvgBrowserFf(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/browser-ff.c33d4458.svg";
export { SvgBrowserFf as ReactComponent };